import { PATHS } from "@/lib/router";
import { BillOcrPage } from "./pages/BillOcrPage";

export const billOcrRoutes = [
  {
    path: PATHS.BILL_OCR,
    element: <BillOcrPage />,
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
];
